export default {
  "common.1": "Tips",
  "common.2": "Confirm",
  "common.3": "Deposit",
  "common.4": "Withdrawal",
  "common.5": "Notice",
  "common.6": "Cancel",
  "common.7": "Successfully received",
  "common.8": "System Tasks",
  "common.9": "Q&A",
  "common.10": "Detailed Records",
  "common.12": "Success",
  "common.13": "Fail",
  "common.14": "In progress",
  "common.20": "Receive",
  "common.21": "No data yet!",
  "common.22": "The request timed out, please try again later",
  "common.23": "Congratulations",
  "home.1": "Award",
  "home.2": "Bonus",
  "home.4": "HOT",
  "home.5": "home.5    /*no value*/",
  "home.6": "home.6    /*no value*/",
  "home.7": "home.7    /*no value*/",
  "home.8": "home.8    /*no value*/",
  "home.9": "home.9    /*no value*/",
  "home.10": "home.10    /*no value*/",
  "home.11": "home.11    /*no value*/",
  "home.12": "home.12    /*no value*/",
  "home.13": "home.13    /*no value*/",
  "home.14": "home.14    /*no value*/",
  "home.15": "home.15    /*no value*/",
  "home.16": "home.16    /*no value*/",
  "home.20": "home.20    /*no value*/",
  "home.21": "home.21    /*no value*/",
  "home.22": "Congratulations to <span style='color: #3ACAFF;'>{userName} </span> for winning cash <span style='color: #FFD645;'>{amount}</span>",
  "home.26": "Casino",
  "home.27": "Wallet",
  "home.28": "Agent",
  "home.29": "My",
  "home.30": "home.30    /*no value*/",
  "home.31": "home.31    /*no value*/",
  "home.32": "home.32    /*no value*/",
  "home.33": "home.33    /*no value*/",
  "home.34": "home.34    /*no value*/",
  "home.35": "home.35    /*no value*/",
  "home.36": "home.36    /*no value*/",
  "home.37": "home.37    /*no value*/",
  "home.38": "Latest bets",
  "home.39": "home.39    /*no value*/",
  "home.40": "Game",
  "home.41": "Bet Value",
  "home.42": "Profit Amount",
  "home.43": "Show more",
  "home.44": "Current VIP Level",
  "home.45": "SuperWin777 is committed to providing players with a lasting, exciting and entertaining gambling experience. We have passed all compliance checks and have the legal authorization to conduct all gambling and betting operations. Final returns cannot be guaranteed.",
  "home.46": "Partners",
  "home.47": "Account abnormality, please check account information",
  "bouns.1": "Recharge Cashback",
  "bouns.2": "Rewards received",
  "bouns.3": "Cashback",
  "bouns.8": "bouns.8    /*no value*/",
  "bouns.9": "bouns.9    /*no value*/",
  "bouns.10": "No reward obtained",
  "bouns.13": "Rule description",
  "bouns.14": "1. After successfully participating in the event and completing the deposit, the cashback amount will be automatically issued to your game account without the need to claim it.\n2. This cashback activity is divided into three times, and you need to participate in sequence. You can start the second time after completing the first time.\n3. Each user can only participate in this activity once. If the system detects the same IP address, bank account, email address and other related information, it will be regarded as the same user. If any cheating is found, the platform has the right to cancel all cashback rewards and close the relevant account.\n4. This platform reserves the right of final interpretation of this event.",
  "bouns.15": "bouns.15    /*no value*/",
  "bouns.16": "1th deposit",
  "bouns.17": "2th deposit",
  "bouns.18": "3th deposit",
  "vip.2": "Weekly Rewards",
  "vip.3": "Monthly Rewards",
  "vip.4": "Withdrawal Privileges",
  "vip.5": "Recharge Cashback",
  "vip.8": "Upgrade VIP",
  "vip.11": "Complete {count} deposit",
  "vip.12": "Log in for 30 consecutive days",
  "vip.14": "Help 2 subordinate members complete a recharge",
  "vip.15": "Upgrade Rewards",
  "vip.18": "Withdrawal Limit",
  "vip.19": "The benefits of <span style='color:#FF8D24;'>VIP{level}</span> are as follows",
  "vip.21": "vip.21    /*no value*/",
  "vip.24": "vip.24    /*no value*/",
  "vip.25": "VIP{level} Privileges",
  "vip.26": "vip.26    /*no value*/",
  "vip.27": "vip.27    /*no value*/",
  "vip.28": "vip.28    /*no value*/",
  "vip.29": "VIP Level",
  "vip.30": "Upgrade to VIP{level}",
  "vip.31": "Game betting refund",
  "vip.32": "Slots",
  "vip.33": "Card games",
  "vip.34": "Sports",
  "vip.35": "Fishing",
  "vip.36": "Bet:<span style = 'color: #FFD645;'>{amount1}</span>/{amount2}",
  "vip.37": "Become a VIP and enjoy the following exclusive benefits",
  "vip.38": "Upgrade to VIP1 user with any deposit",
  "vip.39": "Obtain",
  "vip.40": "Maximum withdrawal amount",
  "vip.41": "You can upgrade to VIP if you meet any of the following conditions",
  "vip.42": "VIP Level",
  "vip.43": "Deposit {amount} and above",
  "vip.46": "Obtain",
  "vip.47": "Help 2 subordinate members complete a recharge",
  "vip.48": "Deposit Amount",
  "invite.1": "Invite friends to earn rewards",
  "invite.2": "Share to your social circle",
  "invite.3": "Share the link with your friends",
  "invite.4": "Copy",
  "invite.5": "Copy Success",
  "invite.6": "My direct reports",
  "invite.7": "{personCount} people",
  "invite.8": "Valid user conditions",
  "invite.9": "Accumulated deposit",
  "invite.10": "Subordinate",
  "invite.11": "Effective",
  "invite.12": "Name",
  "invite.13": "Event Description",
  "invite.14": "1. Invite a corresponding number of new players to open the treasure chest and get rewards\n2.Invited users must complete registration through your exclusive invitation link.\n3.The invited user will be considered as a valid invited user only after he/she completes the deposit of the specified amount.\n4.This platform reserves the right of final interpretation of this event.",
  "proxy.1": "Agent Recruitment",
  "proxy.2": "Invite",
  "proxy.3": "My Links",
  "proxy.4": "Development and rewards for subordinates",
  "proxy.5": "Direct Commission",
  "proxy.6": "Level",
  "proxy.7": "Team Betting Volume",
  "proxy.8": "Proportion",
  "proxy.9": "1.When your subordinate members place bets in the game, you will receive corresponding rewards.\n2.This platform reserves the right of final interpretation of this event.",
  "proxy.10": "My data",
  "proxy.11": "Total Commission",
  "proxy.12": "Total bets",
  "proxy.13": "Total records",
  "proxy.14": "Detailed",
  "proxy.15": "My Commission",
  "proxy.16": "Direct players",
  "proxy.17": "Bet Amount",
  "proxy.18": "The commission for the day will be credited to your account after the early morning settlement",
  "betRefund.1": "Betting Cashback",
  "betRefund.2": "Bets",
  "betRefund.3": "Rebates",
  "betRefund.4": "Promotion progress",
  "betRefund.5": "Next rebate {rate}",
  "betRefund.6": "Rebate Reference Table",
  "betRefund.7": "Bet Amount",
  "betRefund.8": "Rebate Rate",
  "betRefund.9": "1. Users can get cashback rewards by placing bets in the game, and the cashback amount is calculated based on Rebate Reference Table.\n2. Only real and valid bets can participate in cashback, and the system will automatically exclude invalid or abnormal bets.\n3. This platform reserves the right to final interpretation of this event.",
  "lossRefund.1": "Cashback on losses",
  "lossRefund.2": "Loss of the day",
  "lossRefund.3": "Yesterday's loss value",
  "lossRefund.4": "Cashback amount",
  "lossRefund.5": "Loss Rebate Reference Table",
  "lossRefund.6": "Losses in the game",
  "lossRefund.7": "Cashback rate",
  "lossRefund.8": "1. Net losses incurred by users in the game can enjoy cashback subsidies, and the cashback amount is calculated according to the loss cashback reference table\n2. Only eligible game betting losses can participate in cashback, and no refund will be given for violations or abnormal behaviors.\n3. If the player does not receive the cashback amount today, it will be deemed that the player has given up.\n4. If there is cheating or malicious arbitrage behavior, the qualification for participation will be cancelled.\n5. This platform reserves the final right of interpretation of this event",
  "record.1": "Type",
  "record.2": "Amount",
  "record.3": "State",
  "record.4": "Order Number",
  "service.1": "Online Customer Service",
  "service.2": "Working hours: 08:00~24:00",
  "service.3": "How to withdraw funds?",
  "service.4": "Withdrawal is a member-exclusive benefit. You can upgrade to VIP1 user after completing any deposit. After the upgrade, you can withdraw funds immediately.",
  "service.5": "What should I do if I don’t receive the money after a successful recharge?",
  "service.6": "1. Wait for a few minutes. Some payments may be delayed.\n2. Check whether the payment is successful, take a screenshot of the payment voucher and contact customer service for assistance.",
  "service.7": "What should I do if the withdrawal fails or is not received?",
  "service.8": "1. Please carefully confirm whether the withdrawal account information is correct\n2. If the account information is correct and withdrawal fails multiple times, it is recommended to change the account and re-initiate the withdrawal request",
  "service.9": "Is there any fee for withdrawal?",
  "service.10": "Please rest assured that Superwin777 will never charge any withdrawal fees and is committed to creating a fair and transparent gaming environment for players",
  "service.11": "Are there any restrictions on withdrawals?",
  "service.12": "The withdrawal limit increases with the VIP level. The higher the level, the higher the withdrawal limit.",
  "withdraw.1": "Withdrawal Account",
  "withdraw.2": "Add withdrawal account",
  "withdraw.3": "Withdrawable amount",
  "withdraw.4": "Select withdrawal amount",
  "withdraw.5": "Selected withdrawal amount",
  "withdraw.11": "Insufficient cash withdrawal balance",
  "withdraw.14": "The withdrawal slip has been sent to the bank, please pay attention to the changes in the bank account",
  "withdraw.15": "Maximum withdrawal amount",
  "withdraw.16": "The maximum withdrawal amount is the actual value of the account",
  "withdraw.17": "Withdrawal request is being processed",
  "withdraw.18": "Withdrawal in progress",
  "charge.1": "Select deposit amount",
  "charge.2": "Participate in activities",
  "charge.3": "Special rewards for new users",
  "charge.4": "Deposit Amount",
  "charge.5": "Cashback amount",
  "charge.7": "Not participating in activities",
  "charge.8": "charge.8    /*no value*/",
  "account.bind.1": "Add withdrawal account",
  "account.bind.2": "Withdrawal account",
  "account.bind.3": "Please select",
  "account.bind.4": "Account number",
  "account.bind.5": "account.bind.5    /*no value*/",
  "account.bind.6": "User Name",
  "account.bind.7": "Please enter your user name",
  "account.bind.8": "Please enter account number",
  "account.bind.9": "account.bind.9    /*no value*/",
  "account.bind.10": "Format Error",
  "account.bind.11": "account.bind.11    /*no value*/",
  "account.bind.12": "account.bind.12    /*no value*/",
  "account.bind.13": "account.bind.13    /*no value*/",
  "account.bind.14": "Phone number",
  "account.bind.15": "Please enter your phone number",
  "times.1": "times.1    /*no value*/",
  "times.2": "times.2    /*no value*/",
  "times.3": "times.3    /*no value*/",
  "times.4": "times.4    /*no value*/",
  "times.5": "times.5    /*no value*/",
  "times.6": "times.6    /*no value*/",
  "my.1": "Record",
  "my.2": "Language",
  "my.3": "Invite",
  "prop.1": "Dear user:\n     Your withdrawal amount has reached the maximum withdrawal limit of the current <span style=\"color: #FF990B;\">VIP{vipLevel}</span>  level. Please upgrade your VIP level to increase the withdrawal limit before making a withdrawal.",
  "prop.2": "Increase withdrawal amount",
  "prop.3": "prop.3    /*no value*/",
  "prop.4": "Congratulations on receiving the exclusive recharge cashback reward! Your cash reward <span style=\"color: #FF990B;\">{amount}</span> has been added to your account. The bonus can be withdrawn directly without game turnover.",
  "prop.5": "Go to view",
  "prop.6": "Congratulations on upgrading to a <span style=\"color: #FF990B;\">VIP{vipLevel}</span> user. Your upgrade reward <span style='color: #FF990B;'>{amount}</span> has been issued to your account. Please check.",
  "prop.7": "prop.7    /*no value*/",
  "prop.8": "Upgrade VIP level",
  "prop.11": "Your current account balance is insufficient and less than the minimum bet amount",
  "prop.12": "Enter the game",
  "prop.14": "Cash Reward",
  "prop.15": "Congratulations\nCongratulations on winning the welcome bonus\n₱100.00\nJoin the game now to start a wonderful experience and win big prizes!",
  "prop.16": "prop.16    /*no value*/",
  "prop.17": "prop.17    /*no value*/",
  "prop.18": "prop.18    /*no value*/",
  "prop.19": "Deposit ₱200.00 to upgrade to VIP1, then you can withdraw cash",
  "prop.21": "Dear user:\n     Your current VIP level withdrawal limit is {amount}. Please select {amount} to withdraw, or upgrade to VIP2 to get more withdrawal limits.",
  "prop.22": "Select {amount}",
  "prop.34": "prop.34    /*no value*/",
  "prop.35": "<div style='color: #FFB947; font-size: 16rem; font-weight: bold;'>Your balance is now available for withdrawal!</div>\nDeposit <span style='color: #FFB947;'>₱200.00</span> to upgrade to <span style='color: #FFB947;'>VIP1</span> and get withdrawal qualification",
  "prop.36": "Withdrawable balance",
  "prop.37": "Deposit {amount}",
  "prop.38": "Deposit <span style='color: #FFB947;'>₱1,000.00</span> to upgrade to <span style='color: #FFB947;'>VIP2</span>!\nThe maximum withdrawal limit for <span style='color: #FFB947;'>VIP2</span> is <span style='color: #FFB947;'>₱10,000.00</span>.\nAfter becoming VIP2, you can withdraw the full amount immediately",
  "prop.39": "Join the event now and enjoy 100% cash back!\nThe bonus can be withdrawn directly!",
  "prop.40": "Details",
  "prop.41": "Deposit Now",
  "prop.42": "The current VIP level is insufficient. You can choose to play other games or upgrade your VIP level.",
  "prop.43": "Play other games",
  "prop.44": "Dear VIP1 member, you have currently unlocked a withdrawal amount of ₱100.00, go and withdraw it!",
  "home.img.1": "gold_icon_ph.png",
  "home.img.6": "home_icon_vip_in.png",
  "home.img.7": "home_icon_share_in.png",
  "banner.img.1": "banner_1_in.png",
  "banner.img.2": "banner_2_in.png",
  "banner.img.3": "banner_3_in.png",
  "banner.img.4": "banner_4_in.png",
  "banner.img.5": "banner_5_in.png",
  "banner.img.6": "banner_6_in.png",
  "banner.img.7": "banner_7_in.png",
  "activitys.img.1": "cash_des_in.png",
  "activitys.img.4": "newUser_bg_ph.png",
  "activitys.img.6": "cash_amount_in.png",
  "activitys.img.8": "cash_item_complete_in.png",
  "activitys.img.9": "cash_max_in.png",
  "activitys.img.11": "cash_tip_2_in.png",
  "activitys.img.12": "cash_tip_3_in.png",
  "customer.img.1": "customerImg_in.png"
}